/**
 * Custom JavaScript for the theme.
 */

(function () {
  'use strict';

  var CQ_SUPPORTED = typeof window.CSS !== 'undefined' && window.CSS.supports && window.CSS.supports('container-type', 'inline-size');

  /**
   * Contact page: when container queries are unsupported, match Forms .container width to Custom HTML outer .container
   * (same fix as theme.css 100cqw, but pixel-synced for older browsers).
   */
  function syncContactPageContainerWidths() {
    if (CQ_SUPPORTED) return;
    var htmlSec = document.querySelector('.shopify-section[id$="__custom_html_LCb8MF"]');
    var formsSec = document.querySelector('.shopify-section[id$="__apps_forms_contact_inline"]');
    if (!htmlSec || !formsSec) return;
    var ref = htmlSec.querySelector(':scope > section[data-section-type="html"] > .container');
    var box = formsSec.querySelector(':scope > .container');
    if (!ref || !box) return;
    var w = ref.getBoundingClientRect().width * 0.93;
    if (w < 280) return;
    var px = Math.round(w * 100) / 100;
    box.style.setProperty('max-width', px + 'px', 'important');
    box.style.setProperty('width', '100%', 'important');
    box.style.setProperty('margin-left', 'auto', 'important');
    box.style.setProperty('margin-right', 'auto', 'important');
  }

  var rafSyncScheduled = false;
  function scheduleSyncWidths() {
    if (CQ_SUPPORTED) return;
    if (rafSyncScheduled) return;
    rafSyncScheduled = true;
    requestAnimationFrame(function () {
      rafSyncScheduled = false;
      syncContactPageContainerWidths();
    });
  }

  if (!CQ_SUPPORTED) {
    window.addEventListener('resize', function () {
      clearTimeout(window.__cecContactWidthT);
      window.__cecContactWidthT = setTimeout(scheduleSyncWidths, 120);
    });
  }

  /**
   * Shopify Forms inline embed (form-embed or shopify-forms-embed) uses shadow DOM.
   * Theme CSS cannot reach inner inputs; we mirror contact page tokens here.
   * Contact: apps section on page.contact.json. Partner: become-dealer-application. Custom formulation: custom-formulation-form.
   */
  var CONTACT_FORMS_SECTION = '[id$="__apps_forms_contact_inline"]';
  var PARTNER_FORMS_SECTION = '[data-section-type="become-dealer-application"]';
  var CUSTOM_FORMULATION_FORMS_SECTION = '[data-section-type="custom-formulation-form"]';
  var SKIN_ATTR = 'data-cec-contact-forms-skin';

  function shadowSkinCss() {
    return [
      ':host { display: block; width: 100% !important; max-width: 100% !important; min-width: 0 !important; overflow: visible !important; overflow-x: visible !important; box-sizing: border-box !important; --inline-container-max-width: 100% !important; }',
      '* { box-sizing: border-box !important; font-family: "Fira Sans", Arial, sans-serif; min-width: 0 !important; }',
      'svg, svg *, path, img, input[type="checkbox"], input[type="radio"] { min-width: unset !important; max-width: none !important; }',
      '[class*="formContainer"],[class*="_inline_"] { max-width: 100% !important; width: 100% !important; min-width: 0 !important; overflow: visible !important; box-sizing: border-box !important; padding: 2px 12px 10px 6px !important; contain: none !important; }',
      'form,[class*="Fieldset"],[class*="fieldset"] { width: 100% !important; max-width: 100% !important; min-width: 0 !important; box-sizing: border-box !important; overflow: visible !important; contain: none !important; }',
      '/* Native fieldset+legend breaks the top border; draw the frame only on textarea. */',
      'fieldset { border: none !important; outline: none !important; margin: 0 !important; padding: 0 !important; min-inline-size: 0 !important; box-shadow: none !important; }',
      'fieldset legend,fieldset > legend { float: none !important; display: block !important; width: auto !important; max-width: 100% !important; padding: 0 2px 6px 0 !important; margin: 0 !important; border: none !important; position: static !important; }',
      '/* Floating labels need top space; uniform padding collides label + value. */',
      '[class*="Field"],[class*="field"],[class*="TextField"],[class*="text-field"],[class*="TextArea"],[class*="textarea"] { overflow: visible !important; contain: none !important; }',
      'form *:has(textarea) { overflow: visible !important; contain: none !important; }',
      'form *:has(> textarea:not([aria-hidden="true"]):not([hidden])) { overflow: visible !important; contain: none !important; padding: 28px 8px 12px 8px !important; box-sizing: border-box !important; }',
      'h1,h2,h3 { font-family: Futura, "Trebuchet MS", Arial, sans-serif !important; letter-spacing: 0.02em !important; line-height: 1.2 !important; }',
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),select {',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  min-width: 0 !important;',
      '  border-radius: 16px !important;',
      '  border: 1px solid #d9e2ec !important;',
      '  padding: 24px 16px 12px !important;',
      '  font-size: 1rem !important;',
      '  line-height: 1.5 !important;',
      '  color: #241f21 !important;',
      '  background: #ffffff !important;',
      '}',
      '/* Visible message fields only — do not skin honeypot/hidden textareas (was showing a second box under submit). */',
      'textarea:not([aria-hidden="true"]):not([hidden]) {',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  min-width: 0 !important;',
      '  border-radius: 16px !important;',
      '  border: 1px solid #d9e2ec !important;',
      '  padding: 40px 16px 12px !important;',
      '  font-size: 1rem !important;',
      '  line-height: 1.5 !important;',
      '  color: #241f21 !important;',
      '  background: #ffffff !important;',
      '  min-height: 7.5rem !important;',
      '  margin: 10px 0 12px 0 !important;',
      '  background-clip: padding-box !important;',
      '  -webkit-background-clip: padding-box !important;',
      '}',
      'form *:has(> textarea:not([aria-hidden="true"]):not([hidden])) > label { margin-bottom: 10px !important; }',
      'textarea[aria-hidden="true"],textarea[hidden] {',
      '  display: none !important;',
      '  position: absolute !important;',
      '  width: 1px !important;',
      '  height: 1px !important;',
      '  min-height: 0 !important;',
      '  max-height: 0 !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  border: 0 !important;',
      '  overflow: hidden !important;',
      '  clip: rect(0,0,0,0) !important;',
      '  opacity: 0 !important;',
      '  pointer-events: none !important;',
      '}',
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):focus,textarea:not([aria-hidden="true"]):not([hidden]):focus,select:focus {',
      '  outline: none !important;',
      '  border-color: #1793D1 !important;',
      '  box-shadow: inset 0 0 0 1px rgba(23, 147, 209, 0.35) !important;',
      '}',
      'button[aria-haspopup="listbox"],button[aria-expanded][aria-controls] {',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  min-width: 0 !important;',
      '  box-sizing: border-box !important;',
      '  border-radius: 16px !important;',
      '  border: 1px solid #d9e2ec !important;',
      '  padding: 24px 30px 12px 16px !important;',
      '  font-size: 1rem !important;',
      '  text-align: left !important;',
      '  background: #ffffff !important;',
      '  color: #241f21 !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: flex-start !important;',
      '  position: relative !important;',
      '}',
      '/* Chevron pinned to right edge, vertically centered (out of flex flow). */',
      'button[aria-haspopup="listbox"] svg,button[aria-expanded][aria-controls] svg,[role="combobox"] svg {',
      '  position: absolute !important;',
      '  right: 8px !important;',
      '  top: 50% !important;',
      '  transform: translateY(-50%) !important;',
      '  width: 16px !important;',
      '  height: 16px !important;',
      '  min-width: 16px !important;',
      '  min-height: 16px !important;',
      '  max-width: 16px !important;',
      '  max-height: 16px !important;',
      '  display: block !important;',
      '  overflow: visible !important;',
      '  margin: 0 !important;',
      '}',
      'button[aria-haspopup="listbox"] svg path,button[aria-expanded][aria-controls] svg path,[role="combobox"] svg path { stroke-width: 1.5px !important; }',
      'button[aria-haspopup="listbox"] svg polygon,button[aria-expanded][aria-controls] svg polygon { transform: scale(1.2) !important; transform-origin: center !important; }',
      '/* Native select: chevron flush to right inset, vertically centered. */',
      'select { appearance: none !important; -webkit-appearance: none !important; -moz-appearance: none !important; background-color: #ffffff !important;',
      '  background-image: url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27%3E%3Cpath d=%27M6 10l6 6 6-6%27 stroke=%27%23241f21%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E") !important;',
      '  background-repeat: no-repeat !important; background-position: right 8px center !important; background-size: 16px 16px !important;',
      '  padding: 24px 32px 12px 16px !important;',
      '}',
      'button[type="submit"],button[class*="SubmitButton"],button[class*="submit"],button[class*="Submit"] {',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  min-width: 0 !important;',
      '  box-sizing: border-box !important;',
      '  border-radius: 16px !important;',
      '  padding: 14px 24px !important;',
      '  font-family: Futura, "Trebuchet MS", Arial, sans-serif !important;',
      '  font-size: 14px !important;',
      '  font-weight: 600 !important;',
      '  letter-spacing: 0.02em !important;',
      '  text-transform: uppercase !important;',
      '  background: #1793D1 !important;',
      '  color: #ffffff !important;',
      '  border: 2px solid #241f21 !important;',
      '  box-shadow: 6px 6px 0 rgba(41, 59, 101, 0.14) !important;',
      '  cursor: pointer !important;',
      '}',
      '/* Phone (US/CA +1): hide country/flag selector; let tel input span the row. */',
      '.PhoneInputCountry,.PhoneInputCountrySelect,.PhoneInputCountryIcon,',
      '[class*="PhoneInputCountry"],[class*="phoneInputCountry"],[class*="PhoneCountry"],[class*="phone-country"],',
      '[class*="PhoneNumber"] [class*="CountrySelect"],[class*="PhoneInput"] [class*="Country"] {',
      '  display: none !important;',
      '  width: 0 !important;',
      '  min-width: 0 !important;',
      '  max-width: 0 !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  border: none !important;',
      '  overflow: hidden !important;',
      '  flex: 0 0 0 !important;',
      '  visibility: hidden !important;',
      '  pointer-events: none !important;',
      '}',
      '[class*="Field"]:has(input[type="tel"]) > button[aria-haspopup="listbox"],',
      '[class*="Field"]:has(input[type="tel"]) [class*="Row"] > button[aria-haspopup="listbox"]:first-child,',
      'div:has(> input[type="tel"]) > button[aria-haspopup="listbox"]:first-child {',
      '  display: none !important;',
      '}',
      'div[class*="PhoneInput"],div[class*="phone-input"],[class*="PhoneNumberField"],[class*="phone-number"] {',
      '  display: flex !important;',
      '  flex-wrap: nowrap !important;',
      '  align-items: stretch !important;',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  gap: 0 !important;',
      '}',
      'div[class*="PhoneInput"] > input[type="tel"],div[class*="PhoneInput"] input[type="tel"],',
      '[class*="PhoneNumberField"] input[type="tel"] {',
      '  flex: 1 1 100% !important;',
      '  min-width: 0 !important;',
      '  max-width: 100% !important;',
      '}',
      'button[aria-haspopup="listbox"] + div input[type="tel"],',
      'button[aria-haspopup="listbox"] + * input[type="tel"] { min-width: 0 !important; }',
      '/* Phone: outer wrappers often cap width (~50%); match full-width text fields. */',
      '[class*="Field"]:has(input[type="tel"]),',
      '[class*="field"]:has(input[type="tel"]) {',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  min-width: 0 !important;',
      '}',
      '[class*="Field"]:has(input[type="tel"]) > div,',
      '[class*="Field"]:has(input[type="tel"]) [class*="Row"],',
      '[class*="Field"]:has(input[type="tel"]) [role="group"],',
      '[class*="Field"]:has(input[type="tel"]) [class*="Control"],',
      '[class*="Field"]:has(input[type="tel"]) [class*="InputWrapper"],',
      '[class*="Field"]:has(input[type="tel"]) [class*="TextField"],',
      '[class*="Field"]:has(input[type="tel"]) div:has(input[type="tel"]) {',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  min-width: 0 !important;',
      '  flex: 1 1 100% !important;',
      '}',
      'input[type="tel"] {',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  box-sizing: border-box !important;',
      '}',
      'input[type="checkbox"],input[type="radio"] { width: auto !important; padding: 0 !important; border-radius: 4px !important; }'
    ].join('\n');
  }

  function injectSkin(shadowRoot) {
    if (!shadowRoot) return;
    var css = shadowSkinCss();
    var tag = shadowRoot.querySelector('style[' + SKIN_ATTR + ']');
    if (tag) {
      if (tag.textContent === css) return;
      tag.textContent = css;
      return;
    }
    tag = document.createElement('style');
    tag.setAttribute(SKIN_ATTR, '');
    tag.textContent = css;
    shadowRoot.prepend(tag);
  }

  function injectSkinIntoShadowTree(root) {
    if (!root) return;
    injectSkin(root);
    var nodes = root.querySelectorAll('*');
    for (var k = 0; k < nodes.length; k++) {
      var inner = nodes[k].shadowRoot;
      if (inner) injectSkinIntoShadowTree(inner);
    }
  }

  function skinContactFormEmbeds() {
    var scopes = [CONTACT_FORMS_SECTION, PARTNER_FORMS_SECTION, CUSTOM_FORMULATION_FORMS_SECTION];
    for (var s = 0; s < scopes.length; s++) {
      var section = document.querySelector(scopes[s]);
      if (!section) continue;
      var embeds = section.querySelectorAll('form-embed, shopify-forms-embed');
      for (var i = 0; i < embeds.length; i++) {
        var root = embeds[i].shadowRoot;
        if (root) injectSkinIntoShadowTree(root);
      }
    }
  }

  var rafSkinScheduled = false;
  function scheduleSkin() {
    if (rafSkinScheduled) return;
    rafSkinScheduled = true;
    requestAnimationFrame(function () {
      rafSkinScheduled = false;
      skinContactFormEmbeds();
    });
  }

  function onContactPageDocChange() {
    scheduleSyncWidths();
    scheduleSkin();
    scheduleLpFaqBackToTop();
    scheduleCecPdpCartPriceSyncProbe();
  }

  /**
   * Application landing pages (div.lp-*-root): append a secondary “Back to top” row inside
   * section#faq so LP `main { gap: … }` does not space it away from the FAQ card.
   */
  function injectLpFaqBackToTop() {
    var faqs = document.querySelectorAll('[class^="lp-"][class*="-root"] section#faq');
    for (var i = 0; i < faqs.length; i++) {
      var faq = faqs[i];
      if (faq.getAttribute('data-cec-lp-faq-back-top') === '1') continue;
      if (!faq.parentNode) continue;
      faq.setAttribute('data-cec-lp-faq-back-top', '1');
      var wrap = document.createElement('div');
      wrap.className = 'lp-faq-back-top-wrap';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button button--secondary lp-faq-back-top-btn';
      btn.textContent = 'Back to top';
      btn.setAttribute('aria-label', 'Back to top of page');
      btn.addEventListener('click', function () {
        try {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {
          window.scrollTo(0, 0);
        }
        var main = document.getElementById('main');
        if (main && typeof main.focus === 'function') {
          try {
            main.setAttribute('tabindex', '-1');
            main.focus({ preventScroll: true });
          } catch (e2) {}
        }
      });
      wrap.appendChild(btn);
      /* Keep the button inside #faq so LP `main { gap: … }` does not insert ~56–120px between the
         FAQ card and this row (sibling flex items all share the same gap). */
      faq.appendChild(wrap);
    }
  }

  var rafLpFaqScheduled = false;
  function scheduleLpFaqBackToTop() {
    if (rafLpFaqScheduled) return;
    rafLpFaqScheduled = true;
    requestAnimationFrame(function () {
      rafLpFaqScheduled = false;
      injectLpFaqBackToTop();
    });
  }

  /**
   * Product page: show the same discounted unit price as the cart (discount codes / automatic
   * discounts) when that variant is in the cart. Catalog compare-at pricing still comes from Liquid;
   * this keeps the price row in sync after the cart drawer updates without a full reload.
   */
  var cecPdpCartPriceBound = false;
  var cecPdpPriceFetchTimer = null;
  var cecPdpHydrationDelaysScheduled = false;
  var cecPdpMoProbeTimer = null;

  function scheduleCecPdpCartPriceSyncProbe() {
    clearTimeout(cecPdpMoProbeTimer);
    cecPdpMoProbeTimer = setTimeout(function () {
      cecPdpMoProbeTimer = null;
      cecTryInitPdpCartPriceSync();
    }, 80);
  }

  function cecEscapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function cecFormatMoneyCents(cents) {
    var c = typeof cents === 'number' ? cents : parseInt(String(cents), 10);
    if (isNaN(c)) return '';
    var cur = (window.theme && window.theme.shopCurrency) || 'USD';
    var showCode = window.theme && window.theme.currencyCodeEnabled;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cur,
        currencyDisplay: showCode ? 'code' : 'narrowSymbol',
      }).format(c / 100);
    } catch (e) {
      return (c / 100).toFixed(2);
    }
  }

  function cecPdpPriceLists() {
    return document.querySelectorAll('.price-list[data-pdp-price-list]');
  }

  function cecCartLineHasDiscount(it) {
    if (!it) return false;
    if (it.original_price > it.final_price) return true;
    if (it.original_line_price > it.final_line_price) return true;
    var ltd = parseInt(it.line_level_total_discount, 10);
    if (!isNaN(ltd) && ltd > 0) return true;
    var td = parseInt(it.total_discount, 10);
    if (!isNaN(td) && td > 0) return true;
    if (it.discounts && it.discounts.length > 0) return true;
    return false;
  }

  function cecFindCartLineForVariant(cart, variantIdNum) {
    if (!cart || !cart.items || !variantIdNum) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (parseInt(it.variant_id, 10) !== variantIdNum) continue;
      if (cecCartLineHasDiscount(it)) return it;
    }
    return null;
  }

  function cecFindDiscountedCartLineForProduct(cart, productIdNum, variantIdNum) {
    var exact = cecFindCartLineForVariant(cart, variantIdNum);
    if (exact) return exact;
    if (!cart || !cart.items || !productIdNum || isNaN(productIdNum)) return null;
    for (var j = 0; j < cart.items.length; j++) {
      var line = cart.items[j];
      if (parseInt(line.product_id, 10) !== productIdNum) continue;
      if (cecCartLineHasDiscount(line)) return line;
    }
    return null;
  }

  function cecCartLineUnitDisplayCents(cartLine) {
    var orig = parseInt(cartLine.original_price, 10);
    var fin = parseInt(cartLine.final_price, 10);
    if (isNaN(orig)) orig = 0;
    if (isNaN(fin)) fin = 0;
    var save = orig - fin;
    var qty = parseInt(cartLine.quantity, 10) || 0;
    if (save <= 0 && qty > 0) {
      var olp = parseInt(cartLine.original_line_price, 10);
      var flp = parseInt(cartLine.final_line_price, 10);
      if (!isNaN(olp) && !isNaN(flp)) {
        orig = Math.round(olp / qty);
        fin = Math.round(flp / qty);
        save = orig - fin;
      }
    }
    return { orig: orig, fin: fin, save: save };
  }

  function cecReadPdpPromoConfig(form) {
    if (!form) return null;
    var el = form.querySelector('[data-cec-pdp-promo]');
    if (!el) return null;
    var pct = parseInt(el.getAttribute('data-pct'), 10);
    if (!pct || pct < 1 || pct >= 100) return null;
    var handles = (el.getAttribute('data-handles') || '')
      .toLowerCase()
      .split(',')
      .map(function (s) {
        return s.trim().replace(/\s+/g, '');
      })
      .filter(Boolean);
    var prod = (el.getAttribute('data-product-handles') || '')
      .toLowerCase()
      .split('|')
      .filter(Boolean);
    if (!handles.length || !prod.length) return null;
    for (var i = 0; i < prod.length; i++) {
      if (handles.indexOf(prod[i]) !== -1) return { pct: pct };
    }
    return null;
  }

  function cecBuildPdpPriceListInner(variant, cartLine, form) {
    var saleHidden =
      (window.languages && window.languages.productSalePrice) || 'Sale price';
    var regHidden =
      (window.languages && window.languages.productRegularPrice) || 'Regular price';
    var parts = [];
    if (cartLine) {
      var u = cecCartLineUnitDisplayCents(cartLine);
      var showOrig = u.orig;
      var showFin = u.fin;
      var saveAmt = u.save;
      var lineVid = parseInt(cartLine.variant_id, 10);
      var selVid = variant && variant.id != null ? parseInt(variant.id, 10) : NaN;
      if (
        variant &&
        variant.price != null &&
        !isNaN(selVid) &&
        !isNaN(lineVid) &&
        lineVid !== selVid &&
        u.orig > 0 &&
        u.fin < u.orig
      ) {
        var vPx = parseInt(variant.price, 10);
        if (!isNaN(vPx)) {
          showOrig = vPx;
          showFin = Math.round((vPx * u.fin) / u.orig);
          saveAmt = showOrig - showFin;
        }
      }
      parts.push(
        '<span class="price price--highlight"><span class="visually-hidden">' +
          cecEscapeHtml(saleHidden) +
          '</span>' +
          cecFormatMoneyCents(showFin) +
          '</span>'
      );
      parts.push(
        '<span class="price price--compare"><span class="visually-hidden">' +
          cecEscapeHtml(regHidden) +
          '</span>' +
          cecFormatMoneyCents(showOrig) +
          '</span>'
      );
      if (saveAmt > 0 && showOrig > 0) {
        var pct = Math.round((saveAmt * 100) / showOrig);
        var tpl = (window.languages && window.languages.productPricePercentOffHtml) || '';
        var saveLabel = tpl
          ? tpl.replace(/__PERCENT__/g, String(pct))
          : pct + '% off';
        parts.push(
          '<span class="product-form__price-savings">(' + saveLabel + ')</span>'
        );
      }
      return parts.join('');
    }
    var vPrice = variant && variant.price;
    var vCompare = variant && variant.compare_at_price;
    if (vCompare && vPrice && vCompare > vPrice) {
      parts.push(
        '<span class="price price--highlight"><span class="visually-hidden">' +
          cecEscapeHtml(saleHidden) +
          '</span>' +
          cecFormatMoneyCents(vPrice) +
          '</span>'
      );
      parts.push(
        '<span class="price price--compare"><span class="visually-hidden">' +
          cecEscapeHtml(regHidden) +
          '</span>' +
          cecFormatMoneyCents(vCompare) +
          '</span>'
      );
      var saveDiffCat = vCompare - vPrice;
      if (saveDiffCat > 0 && vCompare > 0) {
        var pctCat = Math.round((saveDiffCat * 100) / vCompare);
        var tplCat = (window.languages && window.languages.productPricePercentOffHtml) || '';
        var saveLabelCat = tplCat
          ? tplCat.replace(/__PERCENT__/g, String(pctCat))
          : pctCat + '% off';
        parts.push(
          '<span class="product-form__price-savings">(' + saveLabelCat + ')</span>'
        );
      }
      return parts.join('');
    }
    var promo = cecReadPdpPromoConfig(form);
    if (promo && vPrice) {
      var denom = 100 - promo.pct;
      if (denom > 0) {
        var synth = Math.round((vPrice * 100) / denom);
        if (synth > vPrice) {
          parts.push(
            '<span class="price price--highlight"><span class="visually-hidden">' +
              cecEscapeHtml(saleHidden) +
              '</span>' +
              cecFormatMoneyCents(vPrice) +
              '</span>'
          );
          parts.push(
            '<span class="price price--compare"><span class="visually-hidden">' +
              cecEscapeHtml(regHidden) +
              '</span>' +
              cecFormatMoneyCents(synth) +
              '</span>'
          );
          var tplP = (window.languages && window.languages.productPricePercentOffHtml) || '';
          var saveLP = tplP
            ? tplP.replace(/__PERCENT__/g, String(promo.pct))
            : promo.pct + '% off';
          parts.push(
            '<span class="product-form__price-savings">(' + saveLP + ')</span>'
          );
          return parts.join('');
        }
      }
    }
    parts.push(
      '<span class="price"><span class="visually-hidden">' +
        cecEscapeHtml(saleHidden) +
        '</span>' +
        cecFormatMoneyCents(vPrice) +
        '</span>'
    );
    return parts.join('');
  }

  function cecRefreshPdpPricesFromCart() {
    var lists = cecPdpPriceLists();
    if (!lists.length) return;
    var cartJs =
      window.routes && window.routes.cartUrl
        ? window.routes.cartUrl + '.js'
        : '/cart.js';
    fetch(cartJs, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        lists.forEach(function (list) {
          var form = list.closest('form.product-form');
          if (!form) return;
          var idEl = form.querySelector('[name="id"]');
          if (!idEl) return;
          var vid = parseInt(idEl.value, 10);
          if (isNaN(vid)) return;
          var vpScript = form.querySelector('variant-picker script[data-variant]');
          if (!vpScript) {
            vpScript = form.querySelector('script[data-variant][type="application/json"]');
          }
          var variant = null;
          try {
            variant = vpScript ? JSON.parse(vpScript.textContent) : null;
          } catch (e2) {
            variant = null;
          }
          var productHost = form.closest('product-form');
          var pidAttr =
            (productHost && productHost.getAttribute('data-product-id')) ||
            form.getAttribute('data-product-id');
          var productIdNum = pidAttr ? parseInt(pidAttr, 10) : NaN;
          if (isNaN(productIdNum) && variant && variant.product_id != null) {
            productIdNum = parseInt(variant.product_id, 10);
          }
          var cartLine = cecFindDiscountedCartLineForProduct(cart, productIdNum, vid);
          list.innerHTML = cecBuildPdpPriceListInner(variant, cartLine, form);
        });
      })
      .catch(function () {});
  }

  function cecRefreshPdpPricesFromCartDebounced() {
    clearTimeout(cecPdpPriceFetchTimer);
    cecPdpPriceFetchTimer = setTimeout(cecRefreshPdpPricesFromCart, 60);
  }

  /**
   * Binds cart/variant listeners when a PDP price row exists. Does not require body.template-product
   * (theme editor / edge layouts). Retries via shopify:section:load, MutationObserver probe, and
   * delayed /cart.js fetches so UpCart and preview sessions can hydrate the cart after first paint.
   */
  function cecTryInitPdpCartPriceSync() {
    if (!cecPdpPriceLists().length) return;
    if (!cecPdpCartPriceBound) {
      cecPdpCartPriceBound = true;
      document.addEventListener('cart:refresh', cecRefreshPdpPricesFromCartDebounced);
      document.addEventListener('cart:rerendered', cecRefreshPdpPricesFromCartDebounced);
      document.addEventListener('variant:changed', cecRefreshPdpPricesFromCartDebounced);
      document.addEventListener('variant:change', cecRefreshPdpPricesFromCartDebounced);
      document.addEventListener('product:rerender', cecRefreshPdpPricesFromCartDebounced);
      var upsideEv = [
        'Upside::UCD::CartLoaded',
        'Upside::UCD::CartBuilt',
        'Upside::UCD::CartUpdated',
        'Upside::UCD::ItemAdded',
        'Upside::UCD::ItemChanged',
        'Upside::UCD::CartHidden',
      ];
      for (var ue = 0; ue < upsideEv.length; ue++) {
        window.addEventListener(upsideEv[ue], cecRefreshPdpPricesFromCartDebounced);
      }
      window.addEventListener('focus', cecRefreshPdpPricesFromCartDebounced);
    }
    cecRefreshPdpPricesFromCartDebounced();
    if (!cecPdpHydrationDelaysScheduled) {
      cecPdpHydrationDelaysScheduled = true;
      setTimeout(cecRefreshPdpPricesFromCartDebounced, 400);
      setTimeout(cecRefreshPdpPricesFromCartDebounced, 2000);
    }
  }

  document.addEventListener('shopify:section:load', function () {
    cecTryInitPdpCartPriceSync();
  });

  function cecOnDomContentLoaded() {
    cecTryInitPdpCartPriceSync();
    onContactPageDocChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cecOnDomContentLoaded);
  } else {
    cecOnDomContentLoaded();
  }

  var mo = new MutationObserver(onContactPageDocChange);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
